<template>
  <div class="motion-viz-pro">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>s = f(t) | v = ds/dt$</div>
    </div>

    <div class="viz-grid">
      <!-- 左侧：动态展示 -->
      <div class="panel simulation-panel">
        <div class="panel-label">物理场景模拟</div>
        <div class="road-view">
          <svg width="100%" height="150" viewBox="0 0 400 150">
            <defs>
              <linearGradient id="roadGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stop-color="#1a1a2e" />
                <stop offset="100%" stop-color="#16213e" />
              </linearGradient>
            </defs>
            <rect width="400" height="150" fill="url(#roadGrad)" rx="10" />
            
            <!-- 刻度线 -->
            <g v-for="i in 11" :key="i">
              <line :x1="40 * (i-1)" y1="110" :x2="40 * (i-1)" y2="120" stroke="rgba(255,255,255,0.1)" stroke-width="1" />
              <text :x="40 * (i-1)" y="135" fill="rgba(255,255,255,0.3)" font-size="8" text-anchor="middle">{{ (i-1)*2 }}m</text>
            </g>

            <!-- 小球轨迹发光 -->
            <path :d="`M 0 115 L ${pos * 15} 115`" stroke="#00d2ff" stroke-width="4" stroke-opacity="0.3" fill="none" />
            
            <!-- 物体 P -->
            <g :transform="`translate(${pos * 15}, 115)`">
              <circle r="8" fill="#fff" />
              <circle r="4" fill="#00d2ff" />
              <text y="-15" text-anchor="middle" fill="#00d2ff" font-weight="bold" font-size="10">P</text>
            </g>
          </svg>
        </div>
      </div>

      <!-- 右侧：图表展示 -->
      <div class="panel chart-panel">
        <div class="panel-label">s-t 运动图谱</div>
        <div class="chart-view">
          <svg width="100%" height="200" viewBox="0 0 250 200">
             <defs>
               <marker id="arr-ch" markerWidth="6" markerHeight="4" refX="6" refY="2" orient="auto">
                 <polygon points="0 0, 6 2, 0 4" fill="rgba(255,255,255,0.4)" />
               </marker>
             </defs>
             <!-- 坐标系 -->
             <line x1="30" y1="170" x2="230" y2="170" stroke="rgba(255,255,255,0.4)" marker-end="url(#arr-ch)" />
             <line x1="30" y1="170" x2="30" y2="20" stroke="rgba(255,255,255,0.4)" marker-end="url(#arr-ch)" />
             
             <!-- 曲线轨迹 -->
             <path :d="pathD" fill="none" stroke="#2ed573" stroke-width="2" stroke-linecap="round" />
             
             <!-- 动态指示线 -->
             <line :x1="30 + time * 18" y1="170" :x2="30 + time * 18" :y2="170 - pos * 8" stroke="#ff4757" stroke-dasharray="2,2" />
             <line x1="30" :y1="170 - pos * 8" :x2="30 + time * 18" :y2="170 - pos * 8" stroke="#ff4757" stroke-dasharray="2,2" />
             
             <circle :cx="30 + time * 18" :cy="170 - pos * 8" r="4" fill="#ff4757" />
             <text x="210" y="185" fill="#888" font-size="8">时间 t</text>
             <text x="10" y="25" fill="#888" font-size="8" transform="rotate(-90, 10, 25)">位移 s</text>
          </svg>
        </div>
      </div>
    </div>

    <!-- 增强控制区 -->
    <div class="control-console">
      <div class="slider-row">
        <label><i class="el-icon-timer"></i> 时间轴控制 (t): {{ time.toFixed(1) }}s</label>
        <el-slider v-model="time" :min="0" :max="10" :step="0.05" size="mini"></el-slider>
      </div>
      <div class="status-footer">
        <span>MODE: SYNC_PHYSICS_ENGINE</span>
        <span class="version">V2.1-STABLE</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MotionDescriptionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      time: 0
    }
  },
  computed: {
    // 假设运动方程 s = 0.15t² + 0.5t
    pos() {
      return 0.15 * this.time * this.time + 0.5 * this.time;
    },
    pathD() {
      let d = "M 30 170";
      for (let t = 0; t <= 10; t += 0.2) {
        const s = 0.15 * t * t + 0.5 * t;
        d += ` L ${30 + t * 18} ${170 - s * 8}`;
      }
      return d;
    }
  }
}
</script>

<style scoped lang="scss">
.motion-viz-pro {
  flex: 1; display: flex; flex-direction: column; gap: 15px; height: 100%; overflow: hidden;
}
.viz-header {
  display: flex; justify-content: space-between; align-items: center; padding: 0 10px;
}
.viz-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 15px; flex: 1;
}
.panel {
  background: rgba(10, 10, 20, 0.4); border: 1px solid rgba(255, 255, 255, 0.05); border-radius: 12px; padding: 15px; display: flex; flex-direction: column;
  .panel-label { font-size: 0.7rem; color: #4da1ff; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 10px; opacity: 0.8; }
}
.chart-panel { background: linear-gradient(180deg, rgba(10,10,20,0.4) 0%, rgba(46,213,115,0.05) 100%); }
.control-console {
  background: rgba(255, 255, 255, 0.03); padding: 15px 20px; border-radius: 12px; border: 1px solid rgba(255, 255, 255, 0.05);
  .slider-row { display: flex; align-items: center; gap: 15px; label { white-space: nowrap; color: #ccc; font-size: 0.85rem; } .el-slider { flex: 1; } }
  .status-footer { margin-top: 10px; display: flex; justify-content: space-between; font-size: 0.6rem; color: #444; font-family: monospace; }
}
.road-view, .chart-view { flex: 1; display: flex; align-items: center; justify-content: center; }
</style>
